export const MINIMUM_SHIFT_PATTERN_DAYS = 5;
export const MAXIMUM_SHIFT_PATTERN_DAYS = 56;
export const MAXIMUM_SHIFT_PATTERN_PER_LINE = 28;

export const KARMA_SCORE_COLUMNS = [
    "reliabilityScorePercent",
    "shiftAcceptanceRate",
    "experienceLevel",
    "tierTitle",
];
